module.exports = __webpack_public_path__ + "static/img/e1.7fc07a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/e1.png
// module id = m8Pn
// module chunks = 1